import React, { useState, useEffect } from "react";
import CartList from "./CartList";
import CartDropDownShimmer from "./CartDropDownShimmer";
import { Link } from "react-router-dom";
import { CART_ROUTE } from "../../../routes/web/rootRoutes";
import { formatToINR } from "../../../utils/helper";
import { IoClose } from "react-icons/io5";

const CartDropdown = ({ products, loading, onClose }) => {
  const [closing, setClosing] = useState(false);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => onClose(), 350);
  };

  if (loading) {
    return <>
      <CartDropDownShimmer />
    </>;
  }

  const count = products?.products?.length ?? 0;

  const totalPrice = products?.products?.reduce((acc, curr) => {
    const quantity = curr.quantity || 0;
    const price = curr.product?.finalPrice || 0;
    return acc + quantity * price;
  }, 0);

  return (
    <>
      <div
        className={`fixed  h-[100vh] inset-0 bg-black/60 backdrop-blur-sm z-[500]  transition-opacity duration-300 ${closing ? "opacity-0" : "opacity-100"
          }`}
        onClick={handleClose}
      ></div>

      <div
        className={`cart-drawer fixed top-0 ${closing ? "animate-slide-right" : "animate-slide-left"
          }`}
      >
        <div className="flex items-center justify-between p-4 border-b shadow-sm">
          <h4 className="font-semibold text-lg">My Cart ({count})</h4>

          <button
            onClick={handleClose}
            className="p-2 rounded-full hover:bg-gray-200 transition"
          >
            <IoClose className="text-2xl text-gray-600 hover:text-black transition" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-4 py-3 scrollbar-thin scrollbar-track-gray-200 scrollbar-thumb-gray-400">

          {count === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-center py-10 select-none">
              <span className="text-6xl mb-4">🛒</span>
              <p className="text-lg font-semibold text-gray-700">Your cart is empty</p>
              <p className="text-gray-500 text-sm mt-1">
                Add items to your cart to continue shopping
              </p>
            </div>
          ) : (
            <CartList cartItems={products?.products} />
          )}

        </div>

        <div className="p-4 border-t bg-gray-100">
          <div className="flex items-center justify-between mb-3">
            <p className="text-gray-600 text-sm">({count}) Products</p>
            <p className="font-semibold text-gray-900">
              {formatToINR(totalPrice ?? 0)}
            </p>
          </div>

          <Link
            to={count === 0 ? "#" : CART_ROUTE}
            onClick={count === 0 ? (e) => e.preventDefault() : handleClose}
            className={`w-full block text-center py-3 rounded-xl font-semibold transition ${count === 0
              ? "bg-gray-300 text-gray-600 cursor-not-allowed"
              : "bg-primary text-white hover:bg-primaryDark"
              }`}
          >
            Pay Now
          </Link>
        </div>
      </div>

      <style>{`
        .cart-drawer {
          position: fixed;
          top: 0px;     
          right: 0;
          height: 100vh;
          background: #ffffff;
          width: 85%;
          max-width: 400px;
          z-index: 700;
          box-shadow: -4px 0 20px rgba(0,0,0,0.2);
          display: flex;
          flex-direction: column;
          transform: translateX(100%);
        }

        @media (min-width: 768px) {
          .cart-drawer {
            width: 380px;
          }
        }

        @keyframes slideLeft {
          from { transform: translateX(100%); }
          to   { transform: translateX(0); }
        }

        @keyframes slideRight {
          from { transform: translateX(0); }
          to   { transform: translateX(100%); }
        }

        .animate-slide-left { animation: slideLeft 0.35s ease-out forwards; }
        .animate-slide-right { animation: slideRight 0.35s ease-in forwards; }

        /* scrollbars */
        .scrollbar-thin::-webkit-scrollbar { width: 6px; }
        .scrollbar-thin::-webkit-scrollbar-thumb {
          background: #aaa; border-radius: 20px;
        }
          /* MOBILE OPTIMIZATION */
@media (max-width: 480px) {
  .bottom-nav {
    height: 55px !important;
    padding: 0 8px !important;
  }

  .bottom-nav-item {
    gap: 2px !important;
    transform: scale(0.9); /* icons slightly smaller */
  }

  .bottom-nav-item span {
    font-size: 11px !important;
  }

  .bottom-nav-item svg {
    width: 20px !important;
    height: 20px !important;
  }
}

      `}</style>
    </>
  );
};

export default CartDropdown;
